<template>
<div>
  <b-modal v-model="showRecurrentModal" hide-footer>
    <b-row>
      <b-col>
        <b-button class="mt-3 bg-success" style="min-height: 30px;" block @click="userWantsRecurrent = true, selectPlan(preselectedPlan)">Recorrente, no cartão.*</b-button>
        <p>*Sem fidelidade. Pode cancelar a qualquer momento.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="mt-3 bg-default" style="min-height: 30px;" block @click="selectPlan(preselectedPlan)">Pagamento único</b-button>
      </b-col>
    </b-row>
    <br/>
    <br/>
  </b-modal>
  <b-modal v-model="showFreePassModal" hide-footer>
    <b-row>
      <b-col>
        <p>O plano Free Pass só é disponibilizado em momentos específicos. Infelizmente, ele não está disponível agora.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="mt-3 bg-warning" style="min-height: 30px;" block @click="showFreePassModal = false">Entendi</b-button>
      </b-col>
    </b-row>
    <br/>
    <br/>
  </b-modal>
  <b-row>
    <b-col sm="12" class="text-center">
      <p>*Corresponde ao máximo de Sleekers que podem ser finalizados durante o período de validade do plano.</p>
    </b-col>
  </b-row>
  <div>
    <!-- Contenedor -->
    <div class="pricing-wrapper clearfix">
      <div class="pricing-table">
        <h3 class="pricing-title">Premium</h3>
        <!--<div class="price" style="color: white;">A 60<sup>/ mes</sup></div>-->
        <!-- Lista de Caracteristicas / Propiedades -->
        <ul class="table-list" style="text-align: left;">
          <li class="positive">Até 50 posts <span> por mês*</span></li>
          <li class="positive"><span>Artes para o</span> Feed</li>
          <li class="positive"><span>Artes para </span>Stories</li>
          <li class="positive"><span>Vídeos para </span>Stories e Reels</li>
          <li class="positive">Legenda <span>para os Posts</span></li>
          
          <li class="positive"><span>Calendário de</span> Datas Comemorativas</li>
          <li class="">-</li>
        </ul>
        <!-- Contratar / Comprar -->
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[0].priceInteger : '-'}}</p>
          <a href="#" @click="preselectedPlan = plans[0], showRecurrentModal = true" class="pricing-action">Mensal</a>
        </div>
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[1].priceInteger : '-'}}<sup>3x{{plans ? plans[1].priceIntegerInstallment : '-'}},{{plans ? plans[1].priceDecimalInstallment : '-'}}</sup></p>
          <a href="#" @click="selectPlan(plans[1])" class="pricing-action">Trimestral</a>
        </div>
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[2].priceInteger : '-'}}<sup>/ 6xR${{plans ? plans[2].priceIntegerInstallment : '-'}},{{plans ? plans[2].priceDecimalInstallment : '-'}}</sup></p>
          <a href="#" @click="selectPlan(plans[2])" class="pricing-action">Semestral</a>
        </div>
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[3].priceInteger : '-'}}<sup>/ 12xR${{plans ? plans[3].priceIntegerInstallment : '-'}},{{plans ? plans[3].priceDecimalInstallment : '-'}}</sup></p>
          <a href="#" @click="selectPlan(plans[3])" class="pricing-action">Anual</a>
        </div>
      </div>
      
      <div class="pricing-table recommended">
        <h3 class="pricing-title">VIP</h3>
        <!--<div class="price">$100<sup>/ mes</sup></div>-->
        <!-- Lista de Caracteristicas / Propiedades -->
        <ul class="table-list" style="text-align: left;">
          <li class="positive">Até 100 posts <span> por mês*</span></li>
          <li class="positive"><span>Artes para o</span> Feed</li>
          <li class="positive"><span>Artes para </span>Stories</li>
          <li class="positive"><span>Vídeos para </span>Stories e Reels</li>
          <li class="positive">Legenda <span>para os Posts</span></li>
          
          <li class="positive"><span>Calendário de</span> Datas Comemorativas</li>
          <li class="positive">Gerador de eBook <span class="unlimited">ilimitado</span></li>
        </ul>
        <!-- Contratar / Comprar -->
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[4].priceInteger : '-'}}</p>
          <a href="#" @click="preselectedPlan = plans[0], showRecurrentModal = true" class="pricing-action">Mensal</a>
        </div>
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[5].priceInteger : '-'}}<sup>3x{{plans ? plans[5].priceIntegerInstallment : '-'}},{{plans ? plans[5].priceDecimalInstallment : '-'}}</sup></p>
          <a href="#" @click="selectPlan(plans[5])" class="pricing-action">Trimestral</a>
        </div>
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[6].priceInteger : '-'}}<sup>6x{{plans ? plans[6].priceIntegerInstallment : '-'}},{{plans ? plans[6].priceDecimalInstallment : '-'}}</sup></p>
          <a href="#" @click="selectPlan(plans[6])" class="pricing-action">Semestral</a>
        </div>
        <div class="table-buy" style="font-size: 70%;">
          <p>R${{plans ? plans[7].priceInteger : '-'}}<sup>12x{{plans ? plans[7].priceIntegerInstallment : '-'}},{{plans ? plans[7].priceDecimalInstallment : '-'}}</sup></p>
          <a href="#" @click="selectPlan(plans[7])" class="pricing-action">Anual</a>
        </div>
      </div>

      <div class="pricing-table">
        <h3 class="pricing-title">Free Pass</h3>
        <!--<div class="price">$200<sup>/ mes</sup></div>-->
        <!-- Lista de Caracteristicas / Propiedades -->
        <ul class="table-list" style="text-align: left;">
          <li class="positive">Posts <span class="unlimited">ilimitados</span></li>
          <li class="positive"><span>Artes para o</span> Feed</li>
          <li class="positive"><span>Artes para </span>Stories</li>
          <li class="positive"><span>Vídeos para </span>Stories e Reels</li>
          <li class="positive">Legenda <span>para os Posts</span></li>
          
          <li class="positive"><span>Calendário de</span> Datas Comemorativas</li>
          <li class="positive">Gerador de eBook <span class="unlimited">ilimitado</span></li>
        </ul>
        <!-- Contratar / Comprar -->
        <div class="table-buy">
          <p>R$840<sup>/ 12xR$70</sup></p>
          <a href="#" @click="showFreePassModal = true" class="pricing-action disabled">Indisponível</a>
        </div>
      </div>
    </div>
  </div>
  <b-row class="text-center">
    <b-col sm="4" offset-sm="4" class="col-sm-offset-4 text-center" style="margin-top: 50px; margin-left: 33.33333%">
      <div class="card-body pb-0">
        <b-form>
          <b-input-group class="mb-3">
            <b-form-input
              type="text"
              class="form-control"
              placeholder="Cupom de desconto"
              @keyup.enter.native="$refs.surname.$el.focus()"
              v-model="coupon"
              autocomplete="name"
            />
            <b-input-group-append>
              <b-button variant="primary" @click="validateDiscountCoupon()" :disabled="!coupon" type="button" style="margin-bottom: 4px; min-width: 100px; min-height: 30px;">
                <span>Validar</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <p v-if="couponValidated">Cupom validado!</p>
          <p v-if="couponFailed">Não foi possível validar o cupom</p>
        </b-form>
      </div>
    </b-col>
  </b-row>
  <b-row class="m-t">
    <b-col md="12">
      <payment-history
          :subscription="undefined"
          striped
          caption="<i class='fa fa-align-justify'></i> Histórico de Pagamentos"
        v-if="me && me.subscription" ></payment-history>
      </b-col>
  </b-row>
  <router-view></router-view>
  </div>
   


 
</template>

<script>
import PaymentHistory from "./PaymentHistory";
import SubscriptionBox from "./SubscriptionBox";
import service from "../service";

export default {
  name: "payments",
  data() {
    return {
      selected: [], // Must be an array reference!
      show: true,
      plans: [],
      currentPlanId: undefined,
      currentPlanRecurrent: false,
      me: {},
      paying: false,
      pagseguroNormal: false,
      pagseguroRecurrent: false,
      pagseguroNoCreditCard: false,
      paymentMethod: 0,
      coupon: "",
      couponValidated: false,
      couponFailed: false,
      selectedPlan: {},
      includeEbook: 0,
      options: [
          { text: 'Cartão de Crédito', value: 1 },
          { text: 'Boleto e outros', value: 2 }
        ],
      paymentAlternative: undefined,
      showRecurrentModal: false,
      showFreePassModal: false,
      preselectedPlan: undefined
    };
  },
  methods: {
    click() {
      // do nothing
    },
    getMe: function() {
      service.getMe().then(user => {
        this.me = user;
      });
    },
    subscribePagseguro () {
      this.paying = true;
      let method = "pagseguro-normal"

      if (this.pagseguroRecurrent) {
        method = "pagseguro-recurrent";
      }

      let pagseguroCoupon = undefined;

      if (this.couponValidated) {
        pagseguroCoupon = this.coupon;
      }

      service.subscribePagseguro(this.currentPlanId, method, pagseguroCoupon, this.includeEbook).then(result => {
        this.paying = false;
        if (result && result.paymentURL) {
          localStorage.paymentURL = result.paymentURL;
          this.paymentAlternative = result.paymentURL;
          this.$router.push("/payments/load");
        }
      }).catch(error => {
        this.paying = false;
        if(error && error.message) {
          this.errorMessage = error.message;
        }
      });
    },
    getPlans: function(coupon) {
      service.getPlans(coupon).then(result => {
        this.plans = result.plans;

        if (result.discountedPrices) {
          this.couponValidated = true;
          this.couponFailed = false;
        } else if (coupon) {
          this.couponValidated = false;
          this.couponFailed = true;
        }
      }).catch(() => {
        this.couponFailed = true;
        this.couponValidated = false;
      });
    },
    validateDiscountCoupon() {
      this.getPlans(this.coupon);
    },
    selectPlan(selectedPlan) {
      this.currentPlanId = selectedPlan._id;
      //this.currentPlanRecurrent = selectedPlan.recurrent;
      this.selectedPlan = selectedPlan;

      //if (!this.currentPlanRecurrent) {
        this.pagseguroNormal = true;
        this.pagseguroRecurrent = false;
        this.pagseguroNoCreditCard = false;
        this.paymentMethod = 0;
      //}

      if (this.userWantsRecurrent) {
        this.pagseguroRecurrent = true;
      }

      this.subscribePagseguro();
    }
  },
  created() {
    this.getMe();
    this.getPlans();
    this.$on("UPDATE_ME_PAYMENTS", function() {
      this.me = {};
      this.getMe();
      this.$parent.$emit("UPDATE_ME");
    });
  },
  components: { PaymentHistory, SubscriptionBox }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.m-t {
  margin-top: 20px !important;
}

.padder {
  padding: 40px !important;
}

.text-black {
  color: black !important;
}

.text-white {
  color: white !important;
}














* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body {
  background: #2e2a2a;
  color: #FFF;
  font-size: 62.5%;
  font-family: 'Roboto', Arial, Helvetica, Sans-serif, Verdana;
}

ul {
  list-style-type: none;
}

a {
  color: #4dbd74;
  text-decoration: none;
}

.pricing-table-title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 2.6em;
  color: #FFF;
  margin-top: 15px;
  text-align: left;
  margin-bottom: 25px;
  text-shadow: 0 1px 1px rgba(0,0,0,0.4);
}

.pricing-table-title a {
  font-size: 0.6em;
}

.clearfix:after {
  content: '';
  display: block;
  height: 0;
  width: 0;
  clear: both;
}
/** ========================
 * Contenedor
 ============================*/
.pricing-wrapper {
  width: 960px;
  margin: 40px auto 0;
}

.pricing-table {
  margin: 0 10px;
  text-align: center;
  width: 300px;
  float: left;
  -webkit-box-shadow: 0 0 15px rgba(0,0,0,0.4);
  box-shadow: 0 0 15px rgba(0,0,0,0.4);
  -webkit-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.pricing-table:hover {
  -webkit-transform: scale(1.06);
  -ms-transform: scale(1.06);
  -o-transform: scale(1.06);
  transform: scale(1.06);
}

.pricing-title {
  color: #FFF;
  background: #4dbd74;
  padding: 20px 0;
  font-size: 2em;
  text-transform: uppercase;
  text-shadow: 0 1px 1px rgba(0,0,0,0.4);
}

.pricing-table.recommended .pricing-title {
  background: #2db3cb;
}

.pricing-table.recommended .pricing-action {
  background: #2db3cb;
}

.pricing-table .price {
  background: #403e3d;
  font-size: 3.4em;
  font-weight: 700;
  padding: 20px 0;
  text-shadow: 0 1px 1px rgba(0,0,0,0.4);
}

.pricing-table .price sup {
  font-size: 0.4em;
  position: relative;
  left: 5px;
}

.table-list {
  background: #FFF;
  color: #403d3a;
}

.table-list li {
  font-size: 1.4em;
  font-weight: 700;
  padding: 12px 8px;
}

.table-list .positive:before {
  content: "\f00c";
  font-family: 'FontAwesome';
  color: #3fab91;
  display: inline-block;
  position: relative;
  right: 5px;
  font-size: 16px;
} 

.table-list .negative:before {
  content: "\f05e";
  font-family: 'FontAwesome';
  color: #f00;
  display: inline-block;
  position: relative;
  right: 5px;
  font-size: 16px;
} 

.table-list li span {
  font-weight: 400;
}

.table-list li span.unlimited {
  color: #FFF;
  background: #e95846;
  font-size: 0.9em;
  padding: 5px 7px;
  display: inline-block;
  -webkit-border-radius: 38px;
  -moz-border-radius: 38px;
  border-radius: 38px;
}


.table-list li:nth-child(2n) {
  background: #F0F0F0;
}

.table-buy {
  background: #FFF;
  padding: 15px;
  text-align: left;
  overflow: hidden;
}

.table-buy p {
  float: left;
  color: #37353a;
  font-weight: 700;
  font-size: 2.4em;
}

.table-buy p sup {
  font-size: 0.5em;
  position: relative;
  left: 5px;
}

.table-buy .pricing-action {
  float: right;
  color: #FFF;
  background: #4dbd74;
  padding: 10px 16px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  font-weight: 700;
  font-size: 1.4em;
  text-shadow: 0 1px 1px rgba(0,0,0,0.4);
  -webkit-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.table-buy .pricing-action:hover {
  background: #4dbd74;
}

.recommended .table-buy .pricing-action:hover {
  background: #228799;  
}

/** ================
 * Responsive
 ===================*/
 @media only screen and (min-width: 768px) and (max-width: 959px) {
  .pricing-wrapper {
    width: 768px;
  }

  .pricing-table {
    width: 236px;
  }
  
  .table-list li {
    font-size: 1.3em;
  }

 }

 @media only screen and (max-width: 767px) {
  .pricing-wrapper {
    width: 420px;
  }

  .pricing-table {
    display: block;
    float: none;
    margin: 0 0 20px 0;
    width: 100%;
  }
 }

@media only screen and (max-width: 479px) {
  .pricing-wrapper {
    width: 300px;
  }
} 
</style>
<!--

<script type="text/javascript" src=
"https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js"></script>

<script>
  
</script>-->